import React from 'react';
import { Table } from 'antd';
import { Eye, Store, CircleCheck, CircleX, ReceiptText } from 'lucide-react';
import { IconAction, IconActions, StatusTag, EmptyState } from '../../common';
import PriceTableActions from './PriceTableActions';

export default function PriceTable({ prices, navigatePriceList, rows, setRows, loading }) {
    const openList = (record) => navigatePriceList(`${prices?.find((price) => price.type === record.type)?.id}`);

    const PriceColumns = [
        {
            title: 'Nombre de la Lista',
            dataIndex: 'type',
            key: 'type',
            render: (text, record) => (
                <div className="flex items-center gap-3">
                    <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-[15px] ${
                            record.channel === 'MODERNO' ? 'bg-info-bg text-info-fg' : 'bg-warning-bg text-warning-fg'
                        }`}>
                        <Store />
                    </span>
                    <div className="min-w-0">
                        <span className="block text-sm font-medium text-surface-900">{text}</span>
                        <span className="block text-xs text-surface-500">Lista de precios</span>
                    </div>
                </div>
            ),
            sorter: (a, b) => a.type.localeCompare(b.type)
        },
        {
            title: 'Canal',
            dataIndex: 'channel',
            key: 'channel',
            render: (text) => (
                <StatusTag tone={text === 'MODERNO' ? 'info' : 'warning'}>{text === 'MODERNO' ? 'Moderno' : 'Tradicional'}</StatusTag>
            ),
            filters: [
                { text: 'Moderno', value: 'MODERNO' },
                { text: 'Tradicional', value: 'TRADICIONAL' }
            ],
            onFilter: (value, record) => record.channel === value
        },
        {
            title: 'Estado',
            dataIndex: 'active',
            key: 'active',
            align: 'center',
            render: (active) => (
                <StatusTag tone={active ? 'success' : 'danger'} icon={active ? <CircleCheck /> : <CircleX />}>
                    {active ? 'Activo' : 'Inactivo'}
                </StatusTag>
            ),
            filters: [
                { text: 'Activo', value: true },
                { text: 'Inactivo', value: false }
            ],
            onFilter: (value, record) => record.active === value
        },
        {
            title: 'Acciones',
            key: 'actions',
            align: 'right',
            width: 100,
            render: (_, record) => (
                <IconActions>
                    <IconAction icon={<Eye />} label="Ver Lista" onClick={() => openList(record)} />
                </IconActions>
            )
        }
    ];

    return (
        <section className="shelf-card overflow-hidden">
            <PriceTableActions setRows={setRows} prices={prices} />
            <Table
                dataSource={rows}
                loading={loading}
                columns={PriceColumns}
                scroll={{ x: 'max-content' }}
                locale={{ emptyText: <EmptyState icon={<ReceiptText />} title="No hay listas de precio" description="Crea una lista o ajusta la búsqueda." /> }}
                pagination={{
                    pageSize: 20,
                    showSizeChanger: true,
                    showTotal: (total) => `Total ${total} listas`
                }}
                rowKey="id"
                size="middle"
            />
        </section>
    );
}
